// extracted by mini-css-extract-plugin
module.exports = {"figureContainer":"Bilde_figureContainer___b8cH","figureSmall":"Bilde_figureSmall__bCqmB","figureMedium":"Bilde_figureMedium__Svus6","figureFull":"Bilde_figureFull__y8Reb"};